import React from 'react';
import { PencilIcon, ZapIcon } from 'lucide-react';
import type { FieldSource } from '../../types/quote';
type FieldTagProps = {
  source: FieldSource;
};
export function FieldTag({
  source
}: FieldTagProps) {
  if (source === 'lo') {
    return <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-flame-50 px-2 py-0.5 text-[11px] font-extrabold text-flame-700" data-id="element-48" data-mp="bjuhy45a7pcj">
        <PencilIcon className="h-3 w-3" aria-hidden="true" data-id="element-49" data-mp="klkbpgmmz0dh" />
        LO fills
      </span>;
  }
  return <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-navy-50 px-2 py-0.5 text-[11px] font-extrabold text-navy-700" data-id="element-50" data-mp="gk8t3v26jfes">
      <ZapIcon className="h-3 w-3" aria-hidden="true" data-id="element-51" data-mp="pdlvroq1pve2" />
      Auto-filled
    </span>;
}